import {
  QaService,
  UpdateQuestionData,
  UpdateQuestionResponse,
} from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useUpdateQa(
  mutationOptions?: UseMutationOptions<
    UpdateQuestionResponse,
    HttpError,
    UpdateQuestionData
  >,
) {
  return useMutation({
    mutationFn: QaService.updateQuestion,
    ...mutationOptions,
  });
}

export { useUpdateQa };
